export const textTimelineAnim = {
  eval({ time, params }) {
    const charsPerSec = Math.max(1, params.charsPerSec || 1);
    const totalChars = Math.max(0, params.totalChars || 0);
    const holdSec = Math.max(0, params.holdSec ?? 0.5);
    const showCursor = Boolean(params.showCursor);
    const highlights = Array.isArray(params.highlights) ? params.highlights : [];

    const charCount = Math.min(totalChars, Math.floor(time * charsPerSec));
    const highlightProgresses = highlights.map((hl) => {
      if (time < hl.triggerTime || charCount < hl.charEnd) return 0;
      if (hl.duration <= 0) return 1;
      return Math.max(0, Math.min(1, (time - hl.triggerTime) / hl.duration));
    });

    const done = charCount >= totalChars && time > totalChars / charsPerSec + holdSec;

    return {
      props: {
        charCount,
        time,
        showCursor,
        highlightProgresses,
      },
      done,
    };
  },
};
